import { render, staticRenderFns } from "./OperativeTableBodyRow.vue?vue&type=template&id=2a058f15&"
import script from "./OperativeTableBodyRow.vue?vue&type=script&lang=js&"
export * from "./OperativeTableBodyRow.vue?vue&type=script&lang=js&"
import style0 from "./OperativeTableBodyRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports